import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import './PolicyPages.css';

const someDefinedVariable = "Secure Digital Signatures & Data Protection | DocuSafe Security";

const TermsConditions = () => {
    return (
        <>
            <Helmet>
                <title>{someDefinedVariable || "Default Title"}</title>
                <meta name='description' content='Ensure top-tier data security, e-signature encryption, and compliance with DocuSafe. Protect your documents with blockchain security, AI-powered fraud detection, and GDPR compliance. Stay ahead with secure e-signature solutions today!' />
                <meta name='keywords' content='Secure e-signature, data encryption, digital signature security, blockchain security, AI fraud detection, secure document storage, compliance & privacy, GDPR security, cyber threat protection, electronic signature safety'/>
            </Helmet>
            <section className="policy-container">
                <div className="container">
                    <div className="policy-section">
                        <h1 className="policy-title">Terms and Conditions</h1>
                        <div className="policy-intro">
                            <p className="policy-text">
                                Please read these Terms and Conditions carefully as they outline your legal rights and obligations regarding the use of <strong>DocuSafe</strong> services, including its e-signature platform SignEase.ai. By accessing or using our services, you agree to be bound by these Terms and Conditions.
                            </p>
                            <p className="policy-text">For any questions or concerns, contact us at:</p>
                            <ul className="policy-list">
                                <li className="policy-text"><strong>Email:</strong> <a href="mailto:support@docusafe.ai" className="policy-link">support@docusafe.ai</a></li>
                                <li className="policy-text"><strong>Address:</strong> Redfox Ventures Pte. Ltd., 200 Jalan Sultan, #11-01, Textile Centre, Singapore 199018.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="policy-section">
                        <h3 className="policy-subtitle">1. Definitions and Interpretation</h3>
                        <div className="policy-card">
                            <h4 className="policy-card-title">1.1 Key Definitions:</h4>
                            <ul className="policy-list">
                                <li className="policy-text"><strong>Acceptable Use Policy:</strong> Rules governing the usage of the platform (Schedule 1).</li>
                                <li className="policy-text"><strong>Affiliate:</strong> An entity that controls, is controlled by, or shares control with DocuSafe.ai.</li>
                                <li className="policy-text"><strong>Agreement:</strong> This contract, including any written supplements.</li>
                                <li className="policy-text"><strong>Charges:</strong> The fees payable by the Customer for services rendered.</li>
                                <li className="policy-text"><strong>Customer:</strong> The account holder or user of DocuSafe.ai services.</li>
                                <li className="policy-text"><strong>Data Protection Policy:</strong> Our policy governing the handling of personal and sensitive data.</li>
                                <li className="policy-text"><strong>Platform:</strong> DocuSafe.ai and SignEase.ai, collectively.</li>
                                <li className="policy-text"><strong>Services:</strong> The document management and e-signature services provided through the Platform.</li>
                                <li className="policy-text"><strong>Term:</strong> The duration of the Agreement.</li>
                                <li className="policy-text"><strong>User:</strong> Individuals authorized by the Customer to access and use the Platform.</li>
                            </ul>
                        </div>

                        <div className="policy-card">
                            <h4 className="policy-card-title">1.2 Interpretation:</h4>
                            <p className="policy-text">
                                Clause headings are for reference only and do not affect interpretation.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

const getOriginalContent = (section) => {
    // Keep all the original content but return it with the new styling
    const sections = {
        1: {
            title: "Definitions and Interpretation",
            content: (
                <div>
                    <div className="mb-4">
                        <p className="fw-bold mb-2" style={{ color: "#3498db" }}>1.1 Key Definitions:</p>
                        <ul className="list-unstyled ps-3" style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                            <li className="mb-2"><b>Acceptable Use Policy:</b> Rules governing the usage of the platform (Schedule 1).</li>
                            <li className="mb-2"><b>Affiliate:</b> An entity that controls, is controlled by, or shares control with DocuSafe.ai.</li>
                            <li className="mb-2"><b>Agreement:</b> This contract, including any written supplements.</li>
                            <li className="mb-2"><b>Charges:</b> The fees payable by the Customer for services rendered.</li>
                            <li className="mb-2"><b>Customer:</b> The account holder or user of DocuSafe.ai services.</li>
                            <li className="mb-2"><b>Data Protection Policy:</b> Our policy governing the handling of personal and sensitive data.</li>
                            <li className="mb-2"><b>Platform:</b> DocuSafe.ai and SignEase.ai, collectively.</li>
                            <li className="mb-2"><b>Services:</b> The document management and e-signature services provided through the Platform.</li>
                            <li className="mb-2"><b>Term:</b> The duration of the Agreement.</li>
                            <li className="mb-2"><b>User:</b> Individuals authorized by the Customer to access and use the Platform.</li>
                        </ul>
                    </div>
                    <div>
                        <p className="fw-bold mb-2" style={{ color: "#3498db" }}>1.2 Interpretation:</p>
                        <p className="ps-3" style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                            Clause headings are for reference only and do not affect interpretation.
                        </p>
                    </div>
                </div>
            )
        },
        // Add other sections similarly...
    };
    return sections[section] || { title: "", content: null };
};

export default TermsConditions;
